import { Box, Button, Flex, Modal, Text, ThemeIcon } from "@mantine/core";
import { IconStar } from "@tabler/icons-react";
import ReviewPlatformButtons from "@/components/shared/ReviewPlatformButtons";
import type { ReviewPlatformSource } from "@shared/trustpilot";

const NAVY = "#04305c";

type TrustpilotRatingModalProps = {
  opened: boolean;
  onClose: () => void;
  onRate?: (platform: ReviewPlatformSource) => void;
  title?: string;
  description?: string;
  visiblePlatforms?: ReviewPlatformSource[];
};

export default function TrustpilotRatingModal({
  opened,
  onClose,
  onRate,
  title = "Enjoying GTsetu?",
  description = "Your feedback helps other businesses discover us. Please take a moment to rate us on Trustpilot.",
  visiblePlatforms = ["trustpilot"],
}: TrustpilotRatingModalProps) {
  const handleRate = (platform: ReviewPlatformSource) => {
    onRate?.(platform);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size={560}
      radius="lg"
      padding="lg"
      withCloseButton
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      title={
        <Text fw={700} fz="lg" c={NAVY}>
          {title}
        </Text>
      }
    >
      <Flex direction="column" align="center" gap="md" pt="xs">
        <ThemeIcon size={64} radius="xl" color="teal" variant="light">
          <IconStar size={32} />
        </ThemeIcon>
        <Text ta="center" fz="sm" c="dimmed" maw={420} lh={1.55}>
          {description}
        </Text>
        <Box w="100%" mt="xs">
          <Flex direction="column" gap="sm" align="stretch">
            <ReviewPlatformButtons
              fullWidth
              size="md"
              variant="filled"
              color="teal"
              stackOnMobile
              visiblePlatforms={visiblePlatforms}
              onNavigate={handleRate}
            />
            <Button variant="subtle" color="gray" onClick={onClose}>
              Not now
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Modal>
  );
}
